import IoC from 'ln/ioc/IoC';
import { IoCFactoryFunction } from 'ln/list/ListRenderer';
import Model from 'ln/model/Model';
import Daybreak from './views/Daybreak';
import DaybreakPreview from './views/DaybreakPreview';
import DaybreakModel from './models/DaybreakModel';
import Pause from './views/Pause';
import PauseModel from './models/PauseModel';
import Sequence from './views/Sequence';
import SlrgSequence from './views/SlrgSequence';
import SequencePreview from './views/SequencePreview';
import SlrgSequencePreview from './views/SlrgSequencePreview';
import CustomUserSequence from './views/CustomUserSequence';
import CustomSlrgUserSequence from './views/CustomSlrgUserSequence';
import FeedbackSequence from './views/FeedbackSequence';
import UserSequenceModel from './models/UserSequenceModel';
import CustomUserSequenceModel from './models/CustomUserSequenceModel';
import CustomSlrgUserSequenceModel from './models/CustomSlrgUserSequenceModel';
import Course from "./views/Course";
import CoursePreview from './views/CoursePreview';
import SlrgUserSequenceModel from './models/SlrgUserSequenceModel';
import FeedbackSequenceModel from './models/FeedbackSequenceModel';

class CourseElementsIoC<CourseElementModel> extends IoC<IoCFactoryFunction<Model>> {
    constructor(private courseView:Course|CoursePreview) {
        super();
        this.add( 'App\\Daybreak', function( model:Model) {
            var view = new Daybreak( <DaybreakModel> model, courseView as Course );
            view.render();
            return { node: view.node };
        });
        this.add( 'App\\DaybreakPreview', function( model:Model) {
            var view = new DaybreakPreview( <DaybreakModel> model, courseView as CoursePreview );
            view.render();
            return { node: view.node };
        });
        this.add( 'App\\Pause', function( model:Model ) {
            var view = new Pause( <PauseModel> model, courseView as Course );
            view.render();
            return { node: view.node };
        });
        this.add( 'App\\UserSequence', function( model:Model ) {
            var view = new Sequence( <UserSequenceModel> model, courseView as Course );
            view.render();
            return { node: view.node };
        });
        this.add( 'App\\SlrgUserSequence', function( model:Model ) {
            var view = new SlrgSequence( <SlrgUserSequenceModel> model, courseView as Course );
            view.render();
            return { node: view.node };
        });
        this.add( 'App\\UserSequencePreview', function( model:Model ) {
            var view = new SequencePreview( <UserSequenceModel> model, courseView as CoursePreview );
            view.render();
            return { node: view.node };
        });
        this.add( 'App\\SlrgUserSequencePreview', function( model:Model ) {
            var view = new SlrgSequencePreview( <SlrgUserSequenceModel> model, courseView as CoursePreview );
            view.render();
            return { node: view.node };
        });
        this.add( 'App\\CustomUserSequence', function( model:Model ) {
            var view = new CustomUserSequence( <CustomUserSequenceModel> model, courseView as Course );
            view.render();
            return { node: view.node };
        });
        this.add( 'App\\CustomSlrgUserSequence', function( model:Model ) {
            var view = new CustomSlrgUserSequence( <CustomSlrgUserSequenceModel> model, courseView as Course );
            view.render();
            return { node: view.node };
        });
        this.add( 'App\\FeedbackSequence', function( model:Model ) {
            var view = new FeedbackSequence( <FeedbackSequenceModel> model, courseView as Course );
            view.render();
            return { node: view.node };
        });
    }
}

export default CourseElementsIoC;
